module.exports = __webpack_public_path__ + "static/media/how3.659b4541.svg";